import { isMacOS } from './platformHelpers';

export enum ModifierKeysEnum {
  ALT = 'alt',
  COMMAND = 'command',
  CTRL = 'ctrl',
  OPTION = 'option',
}

/**
 * Get the meta key for the platform. If we are unable to detect the platform,
 * defaults to CTRL.
 *
 * TODO: At some point we may want to add handling for mobile platforms here.
 */
const findMetaKey = (): ModifierKeysEnum.COMMAND | ModifierKeysEnum.CTRL => {
  if (isMacOS()) return ModifierKeysEnum.COMMAND;

  return ModifierKeysEnum.CTRL;
};

export const metaKey = findMetaKey();

export const eventHasMetaKeyForPlatform = (event: KeyboardEvent): boolean => {
  if (metaKey === ModifierKeysEnum.COMMAND) {
    return event.metaKey;
  }

  return event.ctrlKey;
};
